var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isVisibleCondition)?_c('LmConditionalBuilderUi',{staticClass:"col-12",attrs:{"visibilityDependOnConditions":_vm.visibilityDependOnConditions,"self":_vm.component.formObjectToSendToServerProperty}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }